export const bannerOuterCss = "b1bdwxlg";
export const bannerInnerCss = "b1prhlzj";
export const bannerInnerPhoneCss = "bzp1dq1";
export const bannerMessageCss = "brsrm8f";
export const bannerMessagePhoneCss = "b8svz11";
export const bannerActionsCss = "b127utie";
export const bannerButtonCss = "b2tvfzm";

require("./brandRefreshBetaBannerStyles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./brandRefreshBetaBannerStyles.ts");